// @ts-strict-ignore
// import SearchInput from "@dashboard/components/AppLayout/ListFilters/components/SearchInput"; // ADD THIS IMPORT
import { TopNav } from "@dashboard/components/AppLayout/TopNav";
import { DashboardCard } from "@dashboard/components/Card";
import { ListPageLayout } from "@dashboard/components/Layouts";
import { sectionNames } from "@dashboard/intl";
import { SampleRequestListUrlQueryParams, SampleRequestListUrlSortField } from "../../urls";
import { PageListProps, RelayToFlat, SearchPageProps, SortPage } from "@dashboard/types";
// import { Box } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { SampleRequestListDatagrid } from "../SampleRequestListDatagrid/SampleRequestListDatagrid";

// Add this type based on your GraphQL query result
type SampleRequestListQuery = {
  sampleRequests: {
    edges: Array<{
      node: {
        id: string;
        createdAt: string;
        address?: {
          id: string;
          firstName?: string;
          lastName?: string;
          streetAddress1?: string;
          city?: string;
          postalCode?: string;
          country?: {
            code: string;
          };
        };
      };
    }>;
    pageInfo: {
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export interface SampleRequestListPageProps
  extends PageListProps,
    SearchPageProps,
    SortPage<SampleRequestListUrlSortField> {
  sampleRequests: RelayToFlat<SampleRequestListQuery["sampleRequests"]>;
  params: SampleRequestListUrlQueryParams;
  onTrackingIdClick?: (id: string) => void;
}

const SampleRequestListPage = ({
  initialSearch,
  onSearchChange,
  params,
  sampleRequests,
  onSort,
  sort,
  onTrackingIdClick,
  ...listProps
}: SampleRequestListPageProps) => {
  const intl = useIntl();

  return (
    <ListPageLayout>
      <TopNav
        title={intl.formatMessage(sectionNames.sampleRequests)}
        withoutBorder
        isAlignToRight={false}
      />

      <DashboardCard>
        {/* <Box display="flex" alignItems="center" gap={4} paddingBottom={2} paddingX={6}>
          <Box width="320px">
            <SearchInput
              initialSearch={initialSearch}
              placeholder={intl.formatMessage({
                id: "sampleRequestSearch",
                defaultMessage: "Search Sample Requests...",
              })}
              onSearchChange={onSearchChange}
            />
          </Box>
        </Box> */}
        <SampleRequestListDatagrid
          {...listProps}
          sampleRequests={sampleRequests}
          sort={sort}
          onSort={onSort}
          hasRowHover={true}
          onTrackingIdClick={onTrackingIdClick}
        />
      </DashboardCard>
    </ListPageLayout>
  );
};

SampleRequestListPage.displayName = "SampleRequestListPage";
export default SampleRequestListPage;
